
<div style="background-color: rgb(247, 245, 245); height: 100vh;">
<div class="row justify-content-center" >
    <div class=col-3>


    </div>
    <div class=col-3 >
        <div style="text-align: center;">
        <img style="margin-top:20vh; width: 80%" src="assets/img/newLogo.png">
    </div>
    <div class="mb-3"style="text-align: center;">
        <h5 style="font-family: Whitney-reg;margin-top:50px;">Login to your account</h5>
    </div>
        
        <div class="mb-3">
           
            <input type="text" class="form-control" id="formGroupExampleInput" placeholder="Email Address"style="font-family: Whitney-reg;">
          </div>
          <div class="mb-3">
         
            <input type="text" class="form-control" id="formGroupExampleInput2" placeholder="Password"style="font-family: Whitney-reg;">
          </div>
          <div class="mb-3"style="text-align: center;">
         
            <button type="button" class="btn btn-lg btn-block" style="background-color: #0F4980;color:white; padding: 10px 50px; font-family: Whitney-reg; font-size: 1em;cursor: pointer;">Login</button><br>
                <span style="color:#0F4980; padding: 10px 50px; font-family: Whitney-reg; font-size: .8em;cursor: pointer;"(click)="login()">Register a new account</span>
          </div>
    </div>
    <div class=col-3> 
    
        
    </div>
  </div>
  </div>